import { Form } from "react-bootstrap";
import ExtendedSelect from "./ExtendedSelect";

const Input = (props) => {
  const { label, type } = props;
  const { name } = props.field;
  return (
    <Form.Group>
      <Form.Label>{label}</Form.Label>
      <Form.Control
        name={name}
        type={type}
        value={props.form?.values[name]}
        onChange={props.form?.handleChange}
        isInvalid={!!props.form?.errors[name] && props?.form.touched[name]}
      />
      <Form.Control.Feedback type="invalid">
        {props.form?.errors[name]}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

const Select = (props) => {
  const { label, options, loading, disabled, onChange } = props;
  const { name } = props.field;
  return (
    <ExtendedSelect
      label={label}
      name={name}
      value={props.form?.values[name]}
      options={options}
      loading={loading}
      onChange={(e) => {
        props.form?.handleChange(e);
        if (onChange) {
          onChange(e);
        }
      }}
      disabled={disabled}
      errors={props.form?.errors[name]}
      isInvalid={!!props.form?.errors[name] && props?.form.touched[name]}
    />
  );
};

const Checkbox = (props) => {
  const { label, options } = props;
  const { name } = props.field;
  return (
    <Form.Group>
      <Form.Label>{label}</Form.Label>
      {options?.map((option) => (
        <Form.Check
          key={option.value}
          label={option.label || option.name}
          name={name}
          onChange={props.form?.handleChange}
          type={"checkbox"}
          value={option.value}
          id={`checkbox-${name}-${option.value}`}
        />
      ))}
      <Form.Control.Feedback type="invalid">
        {props.form?.errors[name]}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export { Input, Select, Checkbox };
